import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import CampaignComponent from '../components/campaign.component';
import { useNavigate, useParams } from 'react-router-dom';
import storePersist from '../../../../redux/storePersist';
import { tagNames } from '../../../../redux/tag-names/action';
import { useAppDispatch } from '../../../../hooks/hooks';
import { useSelector } from 'react-redux';
import { selectTagNamesListItems } from '../../../../redux/tag-names/selector';
import PageLoader from '../../../../components/PageLoader';
import { campaigns } from '../../../../redux/campaigns/action';
import { selectEmailCampaignsQueryItems } from '../../../../redux/email-campaigns/selector';
import { emailCampaigns } from '../../../../redux/email-campaigns/action';
import { selectAssociatedCampaignListItems } from '../../../../redux/associated-campaign-entity-mappings/selector';
import { associatedCampaign } from '../../../../redux/associated-campaign-entity-mappings/action';
import { selectAssociatedVendorCampaignListItems } from '../../../../redux/associated-campaign-vendor-mapping/selector';
import { associatedVendorCampaign } from '../../../../redux/associated-campaign-vendor-mapping/action';
import { associatedCampaignDSAPMapping } from '../../../../redux/associated-campaign-dsap-mappings/action';
import { selectAssociatedCampaignDSAPMappingListItems } from '../../../../redux/associated-campaign-dsap-mappings/selector';
import { selectDbaAgentDBNAgentMappingsListItems } from '../../../../redux/dba-agent-net-type-dbn-agent-mappings/selector';
import { dbaAgentDBNAgentMappings } from '../../../../redux/dba-agent-net-type-dbn-agent-mappings/action';
import { setDisplayText } from '../../../../service/tag-names.service';

export default function PartnerCampaign ({ id }: any)  {  
  const [pageData, setPageData] = useState(1)
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const customerTags = useSelector(selectTagNamesListItems)
  const [chosenSmsCampaign,setChosenSmsCampaign] = useState<any>([])
  const [chosenEmailCampaign ,setChosenEmailCampaign] = useState<any>([])
  const [chosenWhatsappCampaign,setChosenWhatsappCampaign] = useState<any>([])
  const [choosenCampaign,setChoosenCampaign] = useState<any>([])
  const [selectedTemplate, setSelectedTemplate] = useState<any>();
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const emailCampaignQuery = useSelector(selectEmailCampaignsQueryItems)
  let choosenTemplate: any
  const associatedPartnerListItems = useSelector(selectAssociatedCampaignListItems)
  const associatedVendorListItems = useSelector(selectAssociatedVendorCampaignListItems)
  const userProfileData = storePersist?.get("userProfile")?.current;
  const userProfileAccountId = userProfileData?.items[0]?.Message?.AccountDetail?.Id
    const associatedPartnerItems = useSelector(selectDbaAgentDBNAgentMappingsListItems)
    const itemsData = useSelector(selectAssociatedCampaignDSAPMappingListItems)
  const [
      columnDefs,
      setColumnDefs
    ] = useState({});
    const [
      vendorColumnDefs,
      setVendorColumnDefs
    ] = useState({});
  const [smsTask,setSmsTask] = useState<any>([])
  const [emailTask ,setEmailTask] = useState<any>([])
  const [whatsappTask,setWhatsappTask] = useState<any>([])
  const [emailItem,setEmailItem] = useState<any>([])
  const [whatsappItem,setWhatsappItem] = useState<any>([])
  const [plans,setPlans] = useState<any>([])

  const fetchTagEntitys = async () => {
    dispatch(tagNames.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v3.0/tag/tag-name/query-by-tag-name-list-value`,
      entity: 'tagNames',
      jsonData: {
        Records: [
          {
            EntityType: 17
          } 
        ]
      }
  }))
  }
 
  const fetchEmailCampaignsQueryById = () => {
    dispatch(associatedCampaignDSAPMapping.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/associated-campaign-dsap-mappings/list`, entity: 'associatedCampaignDSAPMapping', jsonData: {
          "Filters": [
            {
            "FieldName": "MappedCampaignId",
            "FilterOperatorId": 1,
            "FieldValue": parmas?.id,
            "FieldType": "number"
            },
            
          ]
        }
    })).then(() => {
      dispatch(emailCampaigns.query({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/campaign/email-campaigns/query`, entity: 'emailCampaigns', jsonData: {

            Records: [
                {

                        "Id": parmas?.id,

                }
            ]

        }
    }))}).then(() => {
        setIsQuery(true)
    }).then(() => {
        setIsLoading(false)
    })

}
  const fetchPlans = async () => {
    // dispatch(plans.list({
    //   url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/plans/list`,
    //   entity:'plans',
    //   jsonData:{}
    // }))
  }
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer (params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'AssociatedEntityId', headerName: 'Associated Entity Id',isEdit: true },
      { field: 'AssociatedEntityName', headerName: 'Associated Entity Name' },
      { field: 'AssociatedEntityType', headerName: 'Associated Entity Type'},
    ]);
  }
  const createVendorColumnDefs: any = () => {
    setVendorColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer (params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'AssociatedEntityId', headerName: 'Associated Entity Id',isEdit: true },
      { field: 'AssociatedEntityName', headerName: 'Associated Entity Name' },
      { field: 'AssociatedEntityType', headerName: 'Associated Entity Type'},
    ]);
  }
  useEffect(() => {
    fetchTagEntitys()
    if (parmas?.id > 0) {
      dispatch(dbaAgentDBNAgentMappings.list({url:`https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/dbn/dba-agent-net-type-dbn-agent-mappings/list`,entity:'associatedPartner',jsonData:{
        "Filters": [
            {
            "FieldName": "IsApprovedByParnter",
            "FilterOperatorId": 1,
            "FieldValue": "true",
            "FieldType": "string"
            },
                    {
                      "FieldName": "AssociatedParnterAgentNetType",
                      "FilterOperatorId": 1,
                      "FieldValue": "DSAPAgent",
                      "FieldType": "text"
                      },
                    {
            "FieldName": "IsApprovedByAssociatedUserProfile",
            "FilterOperatorId": 1,
            "FieldValue": "true",
            "FieldType": "string"
            },
                    {
            "FieldName": "ApprovalStatusId",
            "FilterOperatorId": 1,
            "FieldValue": 20,
            "FieldType": "number"
            },
            {
              "FieldName": "AssociatedUserProfileId",
              "FilterOperatorId": 1,
              "FieldValue": userProfileAccountId,
              "FieldType": "number"
              },
          ],
          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
          
      
          }})).then(() => {
      dispatch(associatedCampaign.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/associated-campaign-entity-mappings/list`, entity: 'associatedCampaign', jsonData: {
            "Filters": [
                {
                  "FieldName": "AssociatedEntityType",
                  "FilterOperatorId": 1,
                  "FieldValue": "Product",
                  "FieldType": "text"
                },
                {
                  "FieldName": "MappedCampaignId",
                  "FilterOperatorId": 1,
                  "FieldValue": parmas?.id,
                  "FieldType": "number"
                },
             ],
              "PageNumber": pageData,
            "PageSize": 10,
            "SortField": "Id",
            "SortOrder": "desc",
        }
      }))}).then(() => {
      dispatch(associatedVendorCampaign.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/associated-campaign-entity-mappings/list`, entity: 'associatedVendorCampaign', jsonData: {
            "Filters": [
                {
                  "FieldName": "AssociatedEntityType",
                  "FilterOperatorId": 1,
                  "FieldValue": "Vendor",
                  "FieldType": "text"
                },
                {
                  "FieldName": "MappedCampaignId",
                  "FilterOperatorId": 1,
                  "FieldValue": parmas?.id,
                  "FieldType": "number"
                },
             ],
              "PageNumber": pageData,
            "PageSize": 10,
            "SortField": "Id",
            "SortOrder": "desc",
        }
      }))})
     
      createVendorColumnDefs()
    createColumnDefs()
      fetchEmailCampaignsQueryById()
      fetchPlans()  
      setIsLoading(false)
    } else {
      setIsLoading(false)
    }
  },[])


  useEffect(
    () => {
        
      if (isQuery) {
        // Ensure that emailCampaignQuery?.result?.items is a valid object or use an empty object
        const campaignItem = { ...emailCampaignQuery?.result?.items }; // Create a shallow copy of the object
      
        // Update the DSAPId in the copied object if itemsData exists
        if (campaignItem && itemsData?.result?.items) {
          campaignItem.DSAPId = itemsData?.result?.items[0]?.DSAPId; // Set the DSAPId
        }
      
        // Update the state immutably by passing the new object
        setChoosenCampaign(campaignItem);
        
        console.log(campaignItem, 'updatedCampaign');
        console.log(itemsData?.result?.items[0]?.DSAPId, 'itemsData?.result?.items');
      }
    },
    [isQuery]
)

  const handleInnerFormChange: any = (event: any, field: string) => {
    setPlans({ ...plans, [field]: event });
  }
  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
     dispatch(campaigns.update({
      url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/campaign/email-campaigns`,
      entity:'campaigns',
      jsonData:{
      Records: [
        {
          choosenCampaign
        }
      ]
    }})).then(()=>{
  back()
    })
    }else{
      dispatch(campaigns.create({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/marketing/campaign/email-campaigns`,
      entity:'campaigns',
      jsonData:{      
      Records: [
        {
          choosenCampaign
        }
      ]
    }})).then(()=>{
    back()
    })
    }
  }
  const back=()=>{
    navigate('/partner/campaign')
  } 
  const libraryListItems = storePersist.get("library")?.current;

  return (
    <>
    {isLoading ? <PageLoader /> :
    <CampaignComponent
    agents={associatedPartnerItems?.result?.items}
      handleInnerFormChange={handleInnerFormChange}
      customerTags={setDisplayText(customerTags?.result?.items)}
      choosenCampaign={choosenCampaign}
      chosenSmsCampaign={chosenSmsCampaign}
      chosenEmailCampaign={chosenEmailCampaign}
      chosenWhatsappCampaign={chosenWhatsappCampaign}
      setSelectedTemplate={setSelectedTemplate}
      selectedTemplate={selectedTemplate}
      choosenTempalte={choosenTemplate}
      smsTask={smsTask}
      emailTask={emailTask}
      whatsappTask={whatsappTask}
      emailItem={emailItem}
      whatsappItem={whatsappItem}
      handleFormSubmit={handleFormSubmit}
      back={back}
      campaignFrequency={libraryListItems.CampaignFrequency}
      id={parmas?.id}
      rowData={associatedPartnerListItems?.result?.items}
      columnDefs={columnDefs}
      setPageData={setPageData}
      paginationData={associatedPartnerListItems?.result?.pagination}
      vendorRowData={associatedVendorListItems?.result?.items}
      VendorpaginationData={associatedVendorListItems?.result?.pagination}
      vendorColumnDefs={vendorColumnDefs}
    />
    }
    </>
  )
}


